import React, { useEffect } from "react";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import { ToastProvider } from "react-toast-notifications";
import { ThemeProvider } from "styled-components";
import { theme } from "../themes";
import { ResetStyle, GlobalStyle } from "../assets/css/globalStyle";
import { SiteProvider } from "../contexts/siteContext";
import Transition from "../components/global/transition";
import Splash from "../components/global/splash";
import { Container } from "../components/global/grid";
import Header from "../components/global/header";
import Footer from "../components/global/footer";
import { NotificationContainer } from "../components/global/notification";
import { LayoutStyle, WrapperStyle, BodyStyle, MainStyle } from "./layout.style";

const isBrowser = typeof window !== "undefined";
const Layout = ({ children, pageContext, location, asideDisplay }) => {
  const localChildren = Array.isArray(children) ? children : [children];
  const asideComponentsLeft = [];
  const asideComponentsRight = [];
  const nonAsideChildren = [];

  localChildren.forEach((c) => {
    if (c?.key?.substr(0, 5) === "Aside") {
      if (c.props.config.self.location === "left") {
        asideComponentsLeft.push(c);
      } else if (c.props.config.self.location === "right") {
        asideComponentsRight.push(c);
      }
    } else {
      nonAsideChildren.push(c);
    }
  });

  useEffect(() => {
    // scroll to top after location changes
    window.scrollTo(0, 0);
    document.body.classList.remove("no-scroll");
  }, [location]);

  return (
    <ThemeProvider theme={theme}>
      <ResetStyle/>
      <GlobalStyle/>

      <SiteProvider pageContext={pageContext}>
        <LayoutStyle>
          {asideComponentsLeft.length > 0 && asideComponentsLeft.map(SideBar => SideBar)}

          <WrapperStyle>
            <Header pageContext={pageContext} location={location} />
            <BodyStyle>
              <MainStyle>
                <Container>
                  <Transition>
                    <ToastProvider
                      components={{ ToastContainer: NotificationContainer }}
                      autoDismiss
                    >
                      {nonAsideChildren}
                    </ToastProvider>
                  </Transition>
                </Container>
              </MainStyle>
            </BodyStyle>
            <Footer />
          </WrapperStyle>
        </LayoutStyle>
      </SiteProvider>
    </ThemeProvider>
  );
};

const ProtectedLayout = isBrowser ? withAuthenticationRequired(Layout, {
  onRedirecting: () => <Splash />,
  loginOptions: document.cookie.split("nopCustomerId=")[1]?.split("=")[0].startsWith("guest_")
    ? {
    fragment: `nopCustomerId=${document.cookie.split("nopCustomerId=")[1]?.split("=")[0].split("guest_")[1]}`,
    }
    : {},
}) : <Splash />;

export default process.env.GATSBY_ACTIVE_ENV === "development"
    ? Layout
    : ProtectedLayout;
